/**
 * 缓存说明:teamAssessmentStore
 */
import vm from './storeTools.js'
import teamAssessmentApi from '@/components/api/teamAssessment/teamAssessmentApi.js'
import unitStore from '@/cache/unitStore.js'
var basestate = {
	allTimeTemplate:undefined,
	deviceAndTeamTree :{},
	teamGroupList:undefined
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getAllTimeTemplate(state, getters) {
			if (state.allTimeTemplate == undefined) {
				store.commit("getAllTimeTemplate")
			}
			return state.allTimeTemplate
		},
		getDeviceGroupTree(state) {
			var unitId = unitStore.state.nowUnit.id
			if(state.deviceAndTeamTree[unitId] == undefined){
				store.commit("getDeviceGroupTree")
				return []
			}
			return state.deviceAndTeamTree[unitId]
		},
		getTeamGroupList(state,getters){
			// var unitId = unitStore.state.nowUnit.id
			if(state.teamGroupList == undefined){
				store.commit('getTeamGroupList')
			}
			return state.teamGroupList
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getDeviceGroupTree(state){
			var unitId = unitStore.state.nowUnit.id
			teamAssessmentApi.getDeviceGroupTree(unitId,respon => {
				vm.Vue.set(state.deviceAndTeamTree,unitId, respon)
			})
		},
		getAllTimeTemplate(state) {
			teamAssessmentApi.getAllTimeTemplate(respon => {
				vm.Vue.set(state, 'allTimeTemplate', respon)
			})
		},
		addTimeTemplate(state,res){
			if(state.allTimeTemplate == undefined){
				vm.Vue.set(state, 'allTimeTemplate', [])
			}
			state.allTimeTemplate.push(res)
		},
		updateTemplate(state, res) {
			for(var i = 0 ,len =state.allTimeTemplate.length;i<len;i++ ) {
				var temp = state.allTimeTemplate[i]
				if(temp.pkid == res.pkid){
					state.allTimeTemplate[i] = res
				}
			}
		},
		getTeamGroupList(state){
			// var unitId = unitStore.state.nowUnit.id
			teamAssessmentApi.getTeamGroupList(respon => {//unitId,
				vm.Vue.set(state, 'teamGroupList', respon)
			})
		}

	}
});

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
